import React from 'react';
import Image from 'next/image';

export default function CardBack() {
  return (
    <div className="absolute inset-0 rounded-xl flex items-center justify-center overflow-hidden" style={{ background: '#e8e8ec' }}>
      <div className="relative" style={{ width: '60%', height: '55%' }}>
        <Image
          src="/assets/images/CrowdStrike_Logo_2023_Secondary_Red-1787827056064.png"
          alt="CrowdStrike logo mark"
          fill
          sizes="120px"
          className="object-contain"
          priority={false}
        />
      </div>
    </div>
  );
}